<template>
  <modal
    :name="`${id}`"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    :click-to-close="true"
    @opened="isModalOn"
    @closed="isModalOff"
  >
    <div class="modal custom-modal is-active">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            New certification
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="$modal.hide(id);"
          />
        </header>
        <section class="modal-card-body content p-md">
          <div class="container content">
            <!-- <h3>Submit Certification</h3> -->
            <p>Start by searching for the property you will submit lead free / safe certification</p>
            <search-property
              ref="search-property"
              @selected-property="startEligiblityCheckProcess"
            />
          </div>
        </section>
      </div>
    </div>
  </modal>
</template>

<script>
import SearchProperty from '@/components/SearchProperty';
export default {
  components: {
    SearchProperty,
  },
  data() {
    return {
      id: `modal_${Math.random().toString(12).substring(2, 8)}`,
    };
  },
  methods: {
    show() {
      this.$modal.show(this.id);
    },
    startEligiblityCheckProcess(property) {
      // Do something here
      this.$refs['search-property'].clear();
      this.$modal.hide(this.id);
      this.$sCache.set('selectedOPAAccountNumber', property.opa_account_num);
      this.$router.push({ name: 'submissions-new', params: { uuid: 'new' }});
    },
  },
};
</script>

<style>

</style>